import * as angular from "angular";
import {IController} from "angular";
import {AccountDialogService} from "../../../account/services/account-dialogs-service.service";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";

export class shipperDetailedViewCtrl implements IController {

  shipper: any;

  /* @ngInject */
  constructor(private accountDialogService: AccountDialogService, private commonsDialogService: CommonsDialogService, private ShippersService,
              private $mdSidenav, private $log) {}

  // ******************************
  //        Public methods
  // ******************************

  editShipperInfo (event) {
    this.accountDialogService.editShipper(event, this.shipper.id);
  }

  editShipperPassword(event) {
    const email = this.shipper.user?.email;
    this.commonsDialogService.editPassword(email, event)
      .then((editedPassword) => {
        this._updateShipperPassword(this.shipper.id, editedPassword)
      })
      .catch(() => {
        this.$log.info('Dialog Closed')
      })
  }

  toggleSidenav() {
    this.$mdSidenav('shipperAccountInfo').toggle();
  }

  // ******************************
  //        Private methods
  // ******************************

  _updateShipperPassword(shipperId, editedPassword) {
    this.ShippersService.updatePassword(shipperId, editedPassword)
      .then((updatedShipper) => {
        this.$log.debug(updatedShipper);
      })
  }

}
angular
  .module('bringoz.admin.shippers')
  .component('shipperDetailedView', {
    bindings : {
      shipper : '<'
    },
    template: require('./shipper-detailed-view.html').default,
    controller: shipperDetailedViewCtrl

  });
